import React, { FC, memo } from "react";
import { CardLoader, Flex, LinearProgress } from "@evergis/ui";

import { Card, CardsContainer, LoadingContainer } from "../../styled";

export const FeatureCardLoader: FC = memo(() => {
  return (
    <CardsContainer>
      <Card>
        <LinearProgress />
        <LoadingContainer>
          <Flex>
            <CardLoader height={48} />
          </Flex>
        </LoadingContainer>
      </Card>
    </CardsContainer>
  );
});
